import { gql } from 'urql';

const SubmitPayOverTimeOnboardingStep = gql`
  mutation SubmitPayOverTimeOnboardingStep(
    $idempotencyId: ID!
    $input: SubmitPayOverTimeSubmitOnboardingInput!
  ) {
    submitPayOverTimeOnboardingStep(
      idempotencyId: $idempotencyId
      input: $input
    ) {
      __typename
      ... on SubmitPayOverTimeOnboardingEmploymentTypes {
        employmentTypes {
          id
          name
        }
      }
      ... on SubmitPayOverTimeOnboardingPaymentPlan {
        registrationInfoId
        agreementId
        agreement {
          __typename
          agreementId
          agreementType
          documentId
        }
        paymentPlanDetails {
          summaryHeadline
          lineItems {
            label
            subLabel
            value
          }
          paymentSchedule {
            title
            scheduleItems {
              label
              amount {
                amount
                currency
                formatted
                formattedWithPlusPrefix
                formattedWithPlusPrefixOrAbs
              }
              dueDate
            }
            disclosureText
          }
        }
      }
      ... on SubmitPayOverTimeOnboardingApplicationDeclined {
        declineReason
      }
      ... on SubmitPayOverTimeOnboardingError {
        code
        title
        message
      }
    }
  }
`;

export default SubmitPayOverTimeOnboardingStep;
